import React from 'react'
import { useWebSettings } from '../Context/WebSettings/WebSettingsContext';
import {Route, Routes, useLocation} from 'react-router-dom';
import { Home } from '../Pages/Home/Home';
import { TimePicker } from '../Pages/TimePicker/TimePicker';
import { Outlets } from '../Pages/Outlets/Outlets';
import { SelectServices } from '../Pages/SelectServices/SelectServices';
import { GuestsAndServices } from '../Pages/GuestsAndServices/GuestsAndServices';
import { ContactDetail } from '../Pages/ContactDetail/ContactDetail';
import PaymentOptions from '../Pages/PaymentOptions/PaymentOptions';
import ManageAppointment from '../Pages/ManageAppointment/ManageAppointment';
import { SelectTime } from '../Pages/TimePicker/SelectTime';
import { ReviewAndConfirmBooking } from '../Pages/ReviewAndConfirmBooking/ReviewAndConfirmBooking';
import { SkipActiveBookingVerification } from '../Components/RouteGuards/SkipActiveBookingVerification';
import { VerifyIdentity } from '../Pages/VerifyIdentity/VerifyIdentity';
import { VerifyOtp } from '../Pages/VerifyOtp/VerifyOtp';
import { BillingDetails } from '../Pages/BillingDetails/BillingDetails';
import { SelectVouchers } from '../Pages/SelectVouchers/SelectVouchers';
import { ReviewVoucherPurchase } from '../Pages/ReviewVoucherPurchase/ReviewVoucherPurchase';
import VoucherSuccessPayment from '../Pages/VoucherSuccessPayment/VoucherSuccessPayment';
import { Maintenance } from '../Pages/Maintenance/Maintenance';
import { NotFound } from '../Pages/NotFound/NotFound';
import { ServerError } from '../Pages/ServerError/ServerError';
import ErrorBoundary from '../Components/ErrorBoundary';
import { RequireBookingVerification } from '../Components/RouteGuards/RequireBookingVerification';


export const Navigation = () => {
  const { pathname } = useLocation();
  const { maintenanceMode, isError, error } = useWebSettings();
  const isDemoPage = ['/server-error', '/maintaince-page', '/maintenance', '/404'].includes(pathname.toLowerCase().replace(/\/$/, ''));

  if (!isDemoPage && maintenanceMode) return <Maintenance />;
  if (!isDemoPage && isError && error?.response?.status >= 500) return <ServerError />;

  return (
    <>
    <Routes>
        <Route path="/404" element={<NotFound />} />
        <Route path="/Maintaince-page" element={<Maintenance />} />
        <Route path="*" element={
          <ErrorBoundary key={pathname} componentName="Not Found Page" fallback={<ServerError />} >
            <NotFound />
          </ErrorBoundary>
        } />

        <Route path="/maintenance" element={
          <ErrorBoundary key={pathname} componentName="Maintenance Page" fallback={<ServerError />} >
            <Maintenance />
          </ErrorBoundary>
        } />

        <Route path="/server-error" element={
          <ErrorBoundary key={pathname} componentName="Server Error Page" fallback={<ServerError />} >
            <ServerError />
          </ErrorBoundary>
        } />

        <Route path="/" element={
          <ErrorBoundary key={pathname} componentName="Home Page" fallback={<ServerError />} >
            <Home/>
          </ErrorBoundary>
        } />

        <Route path="/outlets" element={
          <ErrorBoundary key={pathname} componentName="Outlets Page" fallback={<ServerError />} >
            <Outlets/>
          </ErrorBoundary>
        } />

        <Route path="/select-services" element={
          <ErrorBoundary key={pathname} componentName="Select Services Page" fallback={<ServerError />} >
            <SelectServices/>
          </ErrorBoundary>
        } />

        <Route path="/guests-services" element={
          <ErrorBoundary key={pathname} componentName="Guests & Services Page" fallback={<ServerError />} >
            <GuestsAndServices/>
          </ErrorBoundary>
        } />

        <Route path="/time" element={
          <ErrorBoundary key={pathname} componentName="Time Picker Page" fallback={<ServerError />} >
            <TimePicker />
          </ErrorBoundary>
        } />

        <Route path="/review-and-confirm-booking" element={
          <ErrorBoundary key={pathname} componentName="Review & Confirm Page" fallback={<ServerError />} >
            <ReviewAndConfirmBooking />
          </ErrorBoundary>
        } />

        <Route path="/verify-identity" element={
          <ErrorBoundary key={pathname} componentName="Verify Identity Page" fallback={<ServerError />} >
            <SkipActiveBookingVerification><VerifyIdentity /></SkipActiveBookingVerification>
          </ErrorBoundary>
        } />

        <Route path="/verify-otp" element={
          <ErrorBoundary key={pathname} componentName="Verify OTP Page" fallback={<ServerError />} >
            <SkipActiveBookingVerification><VerifyOtp /></SkipActiveBookingVerification>
          </ErrorBoundary>
        } />

        <Route path="/contact-details" element={
          <RequireBookingVerification>
            <ErrorBoundary key={pathname} componentName="Contact Details Page" fallback={<ServerError />} >
              <ContactDetail />
            </ErrorBoundary>
          </RequireBookingVerification>
        } />

        <Route path="/payment-options" element={
          <ErrorBoundary key={pathname} componentName="Payment Options Page" fallback={<ServerError />} >
            <PaymentOptions />
          </ErrorBoundary>
        } />

        <Route path="/appointment/:uuid" element={
          <ErrorBoundary key={pathname} componentName="Manage Appointment Page" fallback={<ServerError />} >
            <ManageAppointment />
          </ErrorBoundary>
        } />

        <Route path="/appointment/:uuid/select-time" element={
          <ErrorBoundary key={pathname} componentName="Select Time Page" fallback={<ServerError />} >
            <SelectTime />
          </ErrorBoundary>
        } />

        <Route path="/select-vouchers" element={
          <ErrorBoundary key={pathname} componentName="Select Vouchers Page" fallback={<ServerError />} >
            <SelectVouchers />
          </ErrorBoundary>
        } />

        <Route path="/billing-details" element={
          <ErrorBoundary key={pathname} componentName="Billing Details Page" fallback={<ServerError />} >
            <BillingDetails />
          </ErrorBoundary>
        } />

        <Route path="/review-voucher-purchase" element={
          <ErrorBoundary key={pathname} componentName="Review Voucher Purchase Page" fallback={<ServerError />} >
            <ReviewVoucherPurchase />
          </ErrorBoundary>
        } />

        <Route path="/voucher/:orderReference?" element={
          <ErrorBoundary key={pathname} componentName="Voucher Success Payment Page" fallback={<ServerError />} >
            <VoucherSuccessPayment />
          </ErrorBoundary>
        } />
    </Routes>
    </>
  )
}
